import { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { useAuth } from '../../context/AuthContext';
import Layout from '../../components/ui/Layout';
import { SettingsNav } from './Branches';

const ROLE_CONFIG = [
  { key: 'super_admin', name: 'Super admin', desc: 'Full access. Assigned by Agriware only.', colour: '#A32D2D', bg: '#FCEBEB' },
  { key: 'senior_manager', name: 'Senior manager', desc: 'All branches, manage assets, promote staff.', colour: '#993C1D', bg: '#FDF0E8' },
  { key: 'manager', name: 'Manager', desc: 'Branch-scoped checks, incidents, staff.', colour: '#185FA5', bg: '#E6F1FB' },
  { key: 'fuel_manager', name: 'Fuel manager', desc: 'Group-wide Derv management only.', colour: '#085041', bg: '#E1F5EE' },
  { key: 'operator', name: 'Operator', desc: 'Carry out checks on assigned and pool assets.', colour: '#3B6D11', bg: '#EAF3DE' },
  { key: 'driver', name: 'Driver', desc: 'Vehicle and trailer checks only.', colour: '#534AB7', bg: '#EEEDFE' },
];

export default function Roles() {
  const { orgId, userProfile } = useAuth();
  const [userCounts, setUserCounts] = useState({});
  const [loading, setLoading] = useState(true);

  const resolvedOrgId = orgId || userProfile?.orgId;

  useEffect(() => {
    const load = async () => {
      if (!resolvedOrgId) {
        setLoading(false);
        return;
      }
      try {
        const snap = await getDocs(collection(db, 'organisations', resolvedOrgId, 'users'));
        const counts = {};
        snap.docs.forEach(d => {
          const role = d.data().role;
          if (role) counts[role] = (counts[role] || 0) + 1;
        });
        setUserCounts(counts);
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    };
    load();
  }, [resolvedOrgId]);

  return (
    <Layout>
      <div style={{ display: 'flex', flex: 1, minHeight: '100vh' }}>
        <SettingsNav active="Roles" />
        <div style={{ flex: 1, padding: 'var(--main-padding)' }}>
          <h1 style={{ fontSize: 22, fontWeight: 400, marginBottom: 4 }}>Roles</h1>
          <p style={{ fontSize: 13, color: 'var(--color-text-tertiary)', marginBottom: 24 }}>System roles are fixed and cannot be edited.</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 12 }}>
            {ROLE_CONFIG.map(role => {
              const count = userCounts[role.key] || 0;
              return (
                <div key={role.key} style={{ background: 'var(--color-bg-primary)', border: '0.5px solid var(--color-border-light)', borderRadius: 'var(--radius-lg)', padding: '18px 20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                    <div style={{ width: 32, height: 32, borderRadius: 'var(--radius-md)', background: role.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, color: role.colour, fontWeight: 500 }}>
                      {role.name.slice(0, 1)}
                    </div>
                    <div style={{ fontSize: 14, fontWeight: 400, color: 'var(--color-text-primary)' }}>{role.name}</div>
                  </div>
                  <div style={{ fontSize: 13, color: 'var(--color-text-secondary)', marginBottom: 10 }}>{role.desc}</div>
                  <div style={{ fontSize: 12, color: 'var(--color-text-tertiary)' }}>
                    {loading ? '—' : `${count} ${count === 1 ? 'user' : 'users'}`}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Layout>
  );
}